import { Injectable } from '@angular/core';

@Injectable()
export class HeaderService {
  visible: boolean = true;

  hide(): void {
    this.visible = false;
  }

  show(): void {
    this.visible = true;
  }
}
